import { config } from '../config';

function getVisitorId() {
  let id = localStorage.getItem('_vtid');
  if (!id) {
    id = 'v-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    localStorage.setItem('_vtid', id);
  }
  return id;
}

function getSessionId() {
  let id = sessionStorage.getItem('_vsid');
  if (!id) {
    id = 's-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 9);
    sessionStorage.setItem('_vsid', id);
  }
  return id;
}

export function track(eventType, slug, extra = {}) {
  try {
    fetch(`${config.apiUrl}/evt`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        event_type: eventType,
        slug: slug || 'home',
        visitor_id: getVisitorId(),
        session_id: getSessionId(),
        referrer: document.referrer || null,
        ...extra,
      }),
    }).catch(() => {});
  } catch (_) {
    // tracking must never crash the app
  }
}
